import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers as CR, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { fetchMiddleware, wrapCombineReducers } from 'redux-recompose';

import order from './Order/reducer';
import core from './Core/reducer';
import auth from './Auth/reducer';
import disabled from './Disabled/reducer';
import modal from './Modal/reducer';
import stores from './Stores/reducer';
import payments from './Payments/reducer';
import adminUser from './AdminUser/reducer';
import delivery from './Delivery/reducer';
import rejectedOrderManager from './RejectedOrderManager/reducer';
import orderTaker from './OrderTaker/reducer';
import cart from './Cart/reducer';
import { setupMergeState } from './mergeState';

setupMergeState();

const combineReducers = wrapCombineReducers(CR);

export const history = createBrowserHistory();

const reducers = combineReducers({
  router: connectRouter(history),
  order,
  core,
  auth,
  disabled,
  modal,
  stores,
  payments,
  adminUser,
  delivery,
  rejectedOrderManager,
  orderTaker,
  cart
});

const middlewares = [thunk, fetchMiddleware, routerMiddleware(history)];
export const enhancers = [];

enhancers.push(applyMiddleware(...middlewares));

export const composeEnhancers =
  // eslint-disable-next-line no-underscore-dangle
  (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const rootReducer = (state, action) => reducers(state, action);

const store = createStore(rootReducer, composeEnhancers(...enhancers));

export default store;
